module.exports = __webpack_public_path__ + "img/delivery.bc04e209.svg";